export default {
  namespaced: true,
  state () {
    return {
      theme: process.env.APP_THEME
    }
  },
  getters: {
    theme (state) {
      return state.theme
    },
    isLight (state) {
      return state.theme === 'light'
    },
    isDark (state) {
      return state.theme === 'dark'
    }
  },
  mutations: {
    setTheme (state, theme) {
      state.theme = theme
    }
  },
  actions: {
    applyTheme ({ commit }, darkOrLight) {
      commit('setTheme', darkOrLight)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/store/theme.js